import * as React from 'react';

const Printer16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M3.36 1.25C3.36.56 3.918 0 4.61 0h6.777c.69 0 1.25.56 1.25 1.25v2.333h.613A2.75 2.75 0 0 1 16 6.333v3.5a2.75 2.75 0 0 1-2.75 2.75h-.613v2.167c0 .69-.56 1.25-1.25 1.25H4.61c-.69 0-1.25-.56-1.25-1.25v-2.167h-.61A2.75 2.75 0 0 1 0 9.833v-3.5a2.75 2.75 0 0 1 2.75-2.75h.61zm0 9.833V9c0-.69.559-1.25 1.25-1.25h6.777c.69 0 1.25.56 1.25 1.25v2.083h.613c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25H2.75c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25zM11.136 1.5H4.86v2.083h6.278V1.5Zm-6.278 13h6.278V9.25H4.86v5.25Z"
  }
));
Printer16.Size = 16;
Printer16.Title = "Printer";

export { Printer16 as default };
